export default __webpack_public_path__ + "static/page-not-found-694b4357514c818249ee416599778656.png";